/**
 * Lista oficial de EPS de Colombia (a 2026).
 * Fuente: documento entregado por usuario.
 * Mantén el orden y los nombres EXACTOS como aparecen en la nómina oficial.
 */
export const EPS_LIST: readonly string[] = [
  "Coosalud EPS-S",
  "Nueva EPS",
  "Mutual Ser",
  "Salud Mia",
  "Aliansalud EPS",
  "Salud Total EPS S.A.",
  "EPS Sanitas",
  "EPS Sura",
  "Famisanar",
  "Servicio Occidental de Salud EPS SOS",
  "Comfenalco Valle",
  "Compensar EPS",
  "EPM - Empresas Públicas de Medellín",
  "Fondo de Pasivo Social de Ferrocarriles Nacionales de Colombia",
  "Cajacopi Atlántico",
  "Capresoca",
  "Comfachocó",
  "Comfaoriente",
  "EPS Familiar de Colombia",
  "Asmet Salud",
  "Emssanar E.S.S.",
  "Capital Salud EPS-S",
  "Savia Salud EPS",
  "Dusakawi EPSI",
  "Asociación Indígena del Cauca EPSI",
  "Anas Wayuu EPSI",
  "Mallamas EPSI",
  "Pijaos Salud EPSI",
];

export const EPS_OTHER = "Otra";
export const EPS_NONE = "Sisbén / No tengo EPS";

/**
 * Devuelve true si el valor coincide con alguna EPS conocida o con las
 * opciones especiales (Sisbén / No tengo, vacío).
 */
export function isKnownEps(value: string | undefined | null): boolean {
  if (!value) return true;
  if (value === EPS_NONE) return true;
  return EPS_LIST.includes(value);
}
